import React, { useEffect, memo } from 'react';
import { NavigateFunction, Navigate, useNavigate } from 'react-router-dom';
import { Home } from '../component/common/Icon';
import ROUTER_CONSTANT from '../constants/RouterConstant';
import { nativeBridge } from '../utils/NativeBridge';
import { identifyUser, trackEvent } from '../utils/clarity';
import { STORAGE_KEYS } from '../constants/storageKeys';
import { getUid, getUserType } from '../utils/cachedUser';

// Identify by the user's internal id, never the bearer token — the token is a
// live credential and must not leave the device to a third-party analytics
// vendor. If the user object isn't cached yet (very first native login before
// HomePage has fetched it), skip identify rather than send anything sensitive.
function identifyClarityUser() {
    const uid = getUid();
    if (uid) identifyUser(uid, getUserType() || 'UNKNOWN');
}

const Login: React.FC = () => {
    const navigate = useNavigate();

    // Synchronous early-return so a logged-in user landing on `/` or `/login`
    // doesn't see the splash flash before the useEffect redirect fires.
    const initialToken = typeof window !== 'undefined'
        ? localStorage.getItem(STORAGE_KEYS.TOKEN)
        : null;

    useEffect(() => {
        const tryNavigate = () => {
            const storedToken = localStorage.getItem(STORAGE_KEYS.TOKEN);
            if (storedToken) {
                identifyClarityUser();
                navigate(ROUTER_CONSTANT.ROOT.HOME, { replace: true });
            }
        };

        // handles first login: Flutter injects token after page load and fires this event
        window.addEventListener('nativeTokenReady', tryNavigate);
        return () => window.removeEventListener('nativeTokenReady', tryNavigate);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (initialToken) {
        identifyClarityUser();
        return <Navigate to={ROUTER_CONSTANT.ROOT.HOME} replace />;
    }

    return (
        <div style={{
            display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center',
            minHeight: '100svh', background: '#f8fafc',
            gap: '12px', padding: '24px', textAlign: 'center',
        }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '64px', height: '64px' }}><Home size={48} strokeWidth={1.75} /></div>
            <p style={{ fontSize: '20px', fontWeight: 800, color: '#1a1a1a', margin: 0 }}>MyCasa</p>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: 0 }}>Opening your home…</p>
        </div>
    );
}

export function signout(navigate: NavigateFunction) {
    trackEvent('logout');
    nativeBridge.logout();
    localStorage.clear();
    navigate(ROUTER_CONSTANT.ROOT.LOGIN);
}

export default memo(Login)
